import classnames from 'classnames/bind';
import { Theme } from 'app/lib/constants';
import { Icon, IconSize } from 'app/components/core/Icon';
import { useTheme } from 'app/components/core/ThemeProvider';
import * as styles from './Hint.css';

const cx = classnames.bind(styles);

export function Hint({ className, children, theme: themeDefault = Theme.LIGHT, ...props }) {
    const { themeClassname } = useTheme(themeDefault);
    const classes = cx('base', themeClassname, className);

    return (
        <p className={classes} {...props}>
            <Icon variant="info" size={IconSize.EXTRA_SMALL} />
            <span>{children}</span>
        </p>
    );
}
